import { render, staticRenderFns } from "./application-period-end-field.vue?vue&type=template&id=36c24356"
import script from "./application-period-end-field.vue?vue&type=script&lang=js"
export * from "./application-period-end-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports